import React from 'react';
import { motion } from 'framer-motion';
import { BrainCircuit, Target, Clock, AlertCircle } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: BrainCircuit,
    text: 'Estudias y olvidas rápido',
    color: 'text-red-400'
  }, {
    icon: Target,
    text: 'Te cuesta concentrarte',
    color: 'text-orange-400'
  }, {
    icon: Clock,
    text: 'Sientes que pierdes tiempo aprendiendo',
    color: 'text-yellow-400'
  }];
  return <section className="py-24 relative" data-id="element-106">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-107">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-108">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-4" data-id="element-109">
            ¿Te pasa esto?
          </h2>
          <div className="w-24 h-1 bg-cerebro-orange mx-auto rounded-full shadow-[0_0_10px_rgba(249,115,22,0.5)]" data-id="element-110"></div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-111">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="glass-card p-8 flex flex-col items-center text-center hover:border-slate-600 transition-colors" data-id="element-112">
              <div className={`p-4 rounded-full bg-slate-800/80 mb-6 ${problem.color}`} data-id="element-113">
                <problem.icon className="w-8 h-8" data-id="element-114" />
              </div>
              <p className="text-xl font-medium text-slate-200" data-id="element-115">
                {problem.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="max-w-3xl mx-auto text-center glass-card p-8 border-cerebro-blue/30 shadow-[0_0_30px_rgba(59,130,246,0.1)]" data-id="element-116">
          <div className="flex items-center justify-center gap-3 mb-2" data-id="element-117">
            <AlertCircle className="w-6 h-6 text-cerebro-blue" data-id="element-118" />
            <h3 className="text-2xl md:text-3xl font-display font-bold text-white" data-id="element-119">
              No es tu culpa…{' '}
              <span className="text-cerebro-blue" data-id="element-120">es tu método</span>
            </h3>
          </div>
        </motion.div>
      </div>
    </section>;
}